import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import Header from '../topbotm/Header';
import Footer from '../topbotm/Footer';
import Sidebar from '../dashboard/sidebar';
import { Button, Col, Row, Form, Card } from 'react-bootstrap';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import Swal from 'sweetalert2';
import { ToastContainer, toast, Zoom } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { Stack, Typography, Switch } from '@mui/material';
import { styled } from '@mui/material/styles';
import { motion, AnimatePresence } from 'framer-motion';

import api from '../../api';
import { AddClient } from '../client/addcllient';
import { CopyMsg } from '../others/copy_msg';
import { MSGS } from '../others/msg';
import { Dimcontext } from "../../context/pagecontext";
import { AuthContext } from '../../context/authContext';
import { Datacontext } from "../../context/dataContext";
import '../css/others/Doc_Reg.css';

// --- CUSTOM 3-STATE TOGGLE COMPONENT ---
const ThreeStateToggle = ({ value, onChange, disabled }) => {
  // Logic for the sliding thumb
  const getTranslate = () => {
    if (value === 'yes') return 'translateX(38px)'; // Right (Purple)
    if (value === 'no') return 'translateX(2px)';   // Left (Yellow)
    return 'translateX(20px)';                      // Center (Neutral)
  };

  // Background Color Logic
  const getBgColor = () => {
    if (value === 'yes') return '#ece917'; // Theme Yellow
    if (value === 'no') return '#8a2be2';  // Theme Purple
    return '#d1d1d1';                      // Neutral Grey
  };

  // Icon Color Logic (High Contrast)
  const getIconColor = (type) => {
    if (value === null) return '#555'; // Visible grey when neutral
    
    if (type === 'no') {
      // If 'No' is selected, background is Purple (#8a2be2), so icon should be Yellow
      return value === 'no' ? '#ece917' : 'rgba(0, 0, 0, 0.2)';
    }
    
    if (type === 'yes') {
      // If 'Yes' is selected, background is Yellow (#ece917), so icon should be Purple
      return value === 'yes' ? '#4a127e' : '#ece917';
    }
  };


  const handleClick = (e) => {
    if (disabled) return;
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    // Decision logic based on new smaller width (66px)
    if (x < 22) onChange('no');
    else if (x > 44) onChange('yes');
    else onChange(null);
  };

  return (
    <div
      onClick={handleClick}
      style={{
        position: 'relative', 
        width: '66px', 
        height: '26px',
        backgroundColor: getBgColor(), 
        borderRadius: '13px',
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between',
        padding: '0 8px', 
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.6 : 1, 
        transition: 'all 0.3s ease',
        boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.2)',
        border: '1px solid rgba(0,0,0,0.1)'
      }}
    >
      {/* Icons flipped: X on left, Check on right */}
      <span style={{ color: getIconColor('no'), fontWeight: 'bold', zIndex: 1, fontSize: '12px', transition: 'color 0.3s' }}>✕</span>
      <span style={{ color: getIconColor('yes'), fontWeight: 'bold', zIndex: 1, fontSize: '12px', transition: 'color 0.3s' }}>✓</span>
      
      {/* Sliding Thumb */}
      <div style={{
        position: 'absolute', 
        top: '2px', 
        left: '0',
        width: '20px', 
        height: '20px', 
        backgroundColor: '#fff',
        borderRadius: '50%', 
        transition: 'transform 0.3s cubic-bezier(0.4, 0.0, 0.2, 1)',
        transform: getTranslate(), 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
      }}>
        <div style={{ 
          width: '4px', 
          height: '4px', 
          backgroundColor: getBgColor(), 
          borderRadius: '50%',
          transition: 'background-color 0.3s' 
        }} />
      </div>
    </div>
  );
};

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28, height: 16, padding: 0, display: 'flex',
  '&:active': { '& .MuiSwitch-thumb': { width: 15 }, '& .MuiSwitch-switchBase.Mui-checked': { transform: 'translateX(9px)' } },
  '& .MuiSwitch-switchBase': { padding: 2, '&.Mui-checked': { transform: 'translateX(12px)', color: '#fff', '& + .MuiSwitch-track': { opacity: 1, backgroundColor: '#e7ac2d' } } },
  '& .MuiSwitch-thumb': { boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)', width: 12, height: 12, borderRadius: 6, transition: theme.transitions.create(['width'], { duration: 200 }) },
  '& .MuiSwitch-track': { borderRadius: 16 / 2, opacity: 1, backgroundColor: 'rgba(0,0,0,.25)', boxSizing: 'border-box' },
}));

const TitleCase = (str) => {
  return str ? str.toLowerCase().replace(/\s+/g, ' ').split(' ').map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') : "";
};

const RegistrationEc = () => {
  const { user } = useContext(AuthContext);
  const { ec_Count, fetchcountec, users, clients, fetchClients, fetchEc, sOffice, sZone } = useContext(Datacontext);
  const { setDim } = useContext(Dimcontext);

  // Core Form Data State
  const [date, set_Date] = useState("");
  const [app_No, set_App_No] = useState('');
  const [options, set_options] = useState([]);
  const [option_User, set_options_User] = useState([]);
  const [users1, set_users] = useState([]);
  const [ref, set_ref] = useState(null);
  const [off, set_off] = useState(null);
  const [zone, set_zone] = useState(null);
  const [owner, set_Owner] = useState(null);
  const [add, setAdd] = useState(false);
  const [msg, set_msg] = useState(false);
  const [activeMsgText, setActiveMsgText] = useState("");
  const [bt, setBt] = useState(false);
  const [estimatedCost, setEstimatedCost] = useState('');

  // Stepper State
  const [currentStep, setCurrentStep] = useState(1);

  // Document Details Refactored State
  const [docDetails, setDocDetails] = useState({
    ecno: { values: null, no: "", clicked: 0 },
    payment: { values: null, val: "", clicked: 0 },
    ec_received: { values: null, clicked: 0 },
    ec_delivered: { values: null, clicked: 0 }
  });

  const [status, setStatus] = useState({ click: 0, status: 'online' });

  const showToast = (msg) => toast.warn(msg, {
    position: "bottom-center", autoClose: 3000, hideProgressBar: false, closeOnClick: false, pauseOnHover: true, draggable: true, theme: "dark", transition: Zoom,
  });

  const get_customer = useCallback(() => {
    set_options(clients.map((v) => ({ value: v, label: `${v.name?.toUpperCase()} - ${v.nick_name || ""} - ${v.mobile}` })));
  }, [clients]);

  const get_User = useCallback(() => {
    set_options_User(users.map((u) => ({ value: u.name, label: u.name?.toUpperCase() })));
    set_users([{ value: user.name, label: user.name?.toUpperCase() || '' }]);
  }, [users, user]);

  const defaultn = useCallback(() => {
    const today = new Date();
    const d = String(today.getDate()).padStart(2, "0");
    const m = String(today.getMonth() + 1).padStart(2, "0");
    const y = today.getFullYear();
    set_App_No(`TD/EC/${y}/${String(ec_Count?.data?.number).padStart(3, "0")}`);
    set_Date(`${d}-${m}-${y}`);
  }, [ec_Count]);

  useEffect(() => {
    get_User(); defaultn(); get_customer();
  }, [get_User, defaultn, get_customer]);

  const handleCreate_cus = () => { setAdd(true); setDim(true); get_customer(); };

  const handleToggle = (event) => {
    setStatus({ click: status.click + 1, status: event.target.checked ? 'online' : 'offline' });
  };

  const handleDocToggleChange = (field, newValue) => {
  setDocDetails(prev => ({
    ...prev,
    [field]: { 
      ...prev[field], 
      values: newValue 
      // Clicked count is NOT touched here
    }
  }));
};

  const canToggle = (field) => {
    if (user?.role === "user" && docDetails[field].clicked >= 1) return false;
    return true;
  };

  const DATA = { zones: sZone, offices: sOffice };
  const [formData, setFormData] = useState({ zoneId: '', officeId: '' });
  
const formOffices = useMemo(() => (DATA.offices || []).filter(o => o.zoneId === formData.zoneId), [formData.zoneId, DATA.offices]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'zoneId') setFormData({ zoneId: value, officeId: '', villageId: '' });
    else if (name === 'officeId') setFormData({ ...formData, officeId: value, villageId: '' });
    else setFormData({ ...formData, [name]: value });
  };

  const validateMandatory = () => {
    if (!formData.zoneId || !formData.officeId || users1.length === 0) {
      showToast("Application Details (Zone, Office, Managed By) are mandatory!");
      return false;
    }
    if (status.status === 'online' && docDetails.ecno.values === 'yes' && !docDetails.ecno.no) {
      showToast("Please enter the mandatory ECA Number.");
      return false;
  }
  
  // 3. Check Payment if "Yes" is selected for Offline
  if (status.status === 'offline' && docDetails.payment.values === 'yes' && !docDetails.payment.val) {
    showToast("Please enter the Payment value.");
    return false;
  }
    return true;
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  
  if (!validateMandatory()) return;

  const isOnline = status.status === 'online';
    
    const docInfoRow = isOnline 
    ? `
      <p><strong>Encumbrance Certificate Application Status:</strong> ${docDetails.ecno.values?.toUpperCase() || 'PENDING'}</p>
      ${docDetails.ecno.values === 'yes' ? `<p><strong>Encumbrance Certificate Application No:</strong> ${docDetails.ecno.no}</p>` : ''}
    `
    : `
      <p><strong>Encumbrance Certificate Application Status:</strong> ${docDetails.ecno.values?.toUpperCase() || 'PENDING'}</p>
      <p><strong>Payment Status:</strong> ${docDetails.payment.values?.toUpperCase() || 'PENDING'}</p>
      ${docDetails.payment.values === 'yes' ? `<p><strong>Payment Value:</strong> ₹${docDetails.payment.val}</p>` : ''}
    `;

  const summaryHtml = `
    <div style="text-align: left; font-size: 14px; color: #4a127e; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; line-height: 1.6;">
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; padding-bottom: 8px; border-bottom: 2px solid #f0f0f0;">
          <span style="font-size: 16px;"><strong># ${app_No}</strong></span>
          <span style="background-color: ${isOnline ? '#8a2be2' : '#e7ac2d'}; color: white; padding: 4px 10px; border-radius: 20px; font-size: 11px; font-weight: bold; text-transform: uppercase;">
              ${status.status}
          </span>
      </div>
      
      <div style="background-color: #f9f7ff; padding: 10px; border-radius: 8px; margin-bottom: 10px;">
        <p style="margin: 0;"><strong>Zone:</strong> ${zone?.toUpperCase() || 'N/A'}</p>
        <p style="margin: 0;"><strong>Office:</strong> ${typeof off === 'string' ? off.toUpperCase() : off?.label || 'N/A'}</p>
        <p style="margin: 0;"><strong>Managed By:</strong> ${users1.map(u => u.label).join(', ')}</p>
      </div>

      <p><strong>Referred By:</strong> ${ref?.value?.name?.toUpperCase() || 'DIRECT'}</p>
      <p><strong>Executant(owner):</strong> ${owner?.value?.name?.toUpperCase() || 'N/A'}</p>
      
      <div style="margin: 10px 0; padding: 10px; border: 1px dashed #8a2be2; border-radius: 8px;">
        ${docInfoRow}
        <p><strong>Encumbrance Certificate Prepared:</strong> ${docDetails.ec_received.values?.toUpperCase() || 'PENDING'}</p>
        <p><strong>Encumbrance Certificate Delivered:</strong> ${docDetails.ec_delivered.values?.toUpperCase() || 'PENDING'}</p>
      </div>

      <p style="font-size: 15px; text-align: right; margin-top: 10px;">
        <strong>Estimated Cost:</strong> <span style="color: #28a745; font-weight: bold;">${estimatedCost ? `₹${estimatedCost}` : '₹0'}</span>
      </p>
    </div>
  `;

  const result = await Swal.fire({
    title: 'Confirm Submission',
    html: summaryHtml, // logic from previous response
    icon: "question",
    showCancelButton: true,
    confirmButtonColor: "#8a2be2",
  });

  if (!result.isConfirmed) return;
  setBt(true);

  // LOGIC: Increase click count ONLY for fields that were actually filled/changed
  const processClicks = (field) => {
    const currentField = docDetails[field];
    return {
      ...currentField,
      // If a value was selected, click becomes 1, else stays 0
      clicked: currentField.values !== null ? (currentField.clicked + 1) : 0
    };
  };

  const payload = {
    application_no: app_No,
    date: date,
    zone: zone?.toLowerCase(),
    register_office: typeof off === 'string' ? off.toLowerCase() : off?.value?.toLowerCase() || '',
    managed_By: users1.map(u => u.value),
    refered_by: ref?.value || null,
    owner: owner?.value || null,
    status: status || null,
    
    // Apply the click increment here
    ecno: processClicks('ecno'),
    payment: processClicks('payment'),
    ec_received: processClicks('ec_received'),
    ec_delivered: processClicks('ec_delivered'),
    
    estimated_cost: estimatedCost,
    docstatus: 'processing',
  };

  try {
    const res = await api.post('/add_ec', payload);
    
    // Refresh Data
    fetchEc();
    await api.put('ec_count', { year: new Date().getFullYear().toString() });
    fetchcountec();

    Swal.fire({ text: res.data.message, icon: "success", timer: 2000, showConfirmButton: false });
    
    // Reset Form
    setCurrentStep(1);
    set_Owner(null);
    set_ref(null);
    setDocDetails({
      ecno: { values: null, no: "", clicked: 0 },
      payment: { values: null, val: "", clicked: 0 },
      ec_received: { values: null, clicked: 0 },
      ec_delivered: { values: null, clicked: 0 }
    });
    setEstimatedCost('');

  } catch (error) {
    console.error(error);
  } finally {
    setBt(false);
  }
};

  const handleMsg = (type, data) => {
    setActiveMsgText(MSGS[type](data));
    set_msg(true);
    setDim(true);
  };

 const isStep1Complete = useMemo(() => {
  // Mandatory Application Details (Top Card)
  const hasAppDetails = formData.zoneId && formData.officeId && users1.length > 0;
  
  // Applicant Info (Step 1 Card)
  const hasReference = !!ref?.value;   // Added this
  const hasApplicant = !!owner?.value;
  
  return hasAppDetails && hasReference && hasApplicant;
}, [formData, users1, ref, owner]);

// --- STEP 2 VALIDATION ---
const isStep2Complete = useMemo(() => {
  // 1. Check Estimated Cost
  const hasCost = !!estimatedCost;
  
  // 2. Check Primary Conditional Field (Online vs Offline)
  let hasPrimaryDocDetails = false;
  if (status.status === 'online') {
    hasPrimaryDocDetails = docDetails.ecno.values === 'no' || (docDetails.ecno.values === 'yes' && !!docDetails.ecno.no);
  } else {
    const ecno = !!docDetails.ecno.values;
    const pay =docDetails.payment.values === 'no' || (docDetails.payment.values === 'yes' && !!docDetails.payment.val)
    hasPrimaryDocDetails = ecno && pay
  }

  // 3. Check EC Received and EC Delivered (Must not be null/empty)
  // This ensures the user has toggled them to either 'yes' or 'no'
  const hasReceived = !!docDetails.ec_received.values; 
  const hasDelivered = !!docDetails.ec_delivered.values;

  // Step 2 is complete ONLY if all conditions are met
  return hasPrimaryDocDetails && hasCost && hasReceived && hasDelivered;
  
}, [status.status, docDetails, estimatedCost]);

const validateCurrentStep = (stepToValidate = currentStep) => {
    switch (stepToValidate) {
        case 1:
            // --- Mandatory Application Details (Top Card) ---
            if (!formData.zoneId) { showToast("Please select a Zone."); return false; }
            if (!formData.officeId) { showToast("Please select an Office."); return false; }
            if (!users1 || users1.length === 0 || !users1.every(user => !!user)) { showToast("Please assign at least one User."); return false; }
            break;

        case 2:
            if (status.status === 'online') {
                if (docDetails.ecno.values === 'yes' && !docDetails.ecno.no) {
                    showToast("Please provide the EC Number.");
                    return false;
                }
            } else {
                if (docDetails.payment.values === 'yes' && !docDetails.payment.val) {
                    showToast("Please enter the Payment Value details.");
                    return false;
                }
            }
            break;
            
        default:
            break;
    } // <--- ADDED MISSING CLOSING BRACE FOR SWITCH STATEMENT

    return true; // All checks passed, allows navigation
};

const selectStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: '38px',
      borderRadius: '0.375rem',
      borderColor: state.isFocused ? 'var(--brand-purple)' : '#dee2e6',
      boxShadow: state.isFocused ? '0 0 0 1px var(--brand-purple)' : 'none',
      '&:hover': {
        borderColor: 'var(--brand-purple)'
      }
    }),
    // This ensures the menu is physically moved to the <body> 
    // so it ignores "overflow: hidden" on your Cards
    menuPortal: (base) => ({ 
      ...base, 
      zIndex: 9999 
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected 
        ? 'var(--brand-purple)' 
        : state.isFocused 
        ? 'rgba(74, 18, 126, 0.1)' 
        : 'white',
      color: state.isSelected ? 'white' : 'var(--bs-body-color)',
    })
  };

//   const handleStepClick = (targetStep) => {
//   // 1. FREE BACKWARD TRAVEL
//   if (targetStep < currentStep) {
//     setCurrentStep(targetStep);
//     return;
//   }

//   // 2. PROTECTED FORWARD TRAVEL
//   if (targetStep > currentStep) {
//     if (!validateCurrentStep(currentStep)) {
//       return; // Stop. The precise error Toast has already been shown.
//     }
//     setCurrentStep(targetStep);
//   }
// };

  return (
    <div className="dashboard-page bg-light min-vh-100">
      <Header />
      <ToastContainer autoClose={3000} />
      <div className="dashboard-wrapper">
        <div className="d-none" style={{ backgroundColor: "#4a127e" }}>
          <Sidebar user={user} />
        </div>

        <main className="main-area py-4">
          <div className="container-xxl">
            
            {/* CONSTANT HEADER: Application Details (Always Visible - Yellow/Purple Theme) */}
            <Card className="shadow-sm border-0 mb-4 rounded-3" style={{ borderTop: '5px solid #e7ac2d' }}>
              <Card.Header className="border-0 pt-4 px-4" style={{ backgroundColor: '#fffdf5' }}>
                <div className="d-flex align-items-center">
                  <div className="rounded-circle me-2" style={{ width: '8px', height: '8px', backgroundColor: '#e7ac2d' }}></div>
                  <h5 className="fw-bold mb-0" style={{ color: "#4a127e", letterSpacing: '-0.3px' }}>
                    Application Details
                  </h5>
                </div>
              </Card.Header>

              <Card.Body className="px-4 pb-4" style={{ backgroundColor: '#fffdf5' }}>
                <Row className="g-3">
                  {/* Read-Only: Application No. */}
                  <Form.Group as={Col} xs={12} sm={6} md={4}>
                    <Form.Label className="small fw-bold text-muted text-uppercase mb-1" style={{ fontSize: '0.7rem' }}>
                      Application No.
                    </Form.Label>
                    <Form.Control 
                      type="text" 
                      value={app_No} 
                      readOnly 
                      className="bg-white border-0 shadow-none fw-semibold text-dark" 
                      style={{ height: '40px' }}
                    />
                  </Form.Group>

                  {/* Read-Only: Date */}
                  <Form.Group as={Col} xs={12} sm={6} md={4}>
                    <Form.Label className="small fw-bold text-muted text-uppercase mb-1" style={{ fontSize: '0.7rem' }}>
                      Date
                    </Form.Label>
                    <Form.Control 
                      type="text" 
                      value={date} 
                      readOnly 
                      className="bg-white border-0 shadow-none fw-semibold text-dark" 
                      style={{ height: '40px' }}
                    />
                  </Form.Group>

                  {/* Select: Zone */}
                  <Form.Group as={Col} xs={12} sm={6} md={4}>
                    <Form.Label className="small fw-bold text-muted text-uppercase mb-1" style={{ fontSize: '0.7rem' }}>
                      Zone <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select 
                      className="shadow-none border-secondary-subtle fw-semibold"
                      style={{ height: '40px', fontSize: '14px' }}
                      name="zoneId" 
                      value={formData.zoneId || ""} 
                      onChange={(e) => { 
                        handleChange(e); 
                        set_zone(DATA.zones.find(v => v.id === e.target.value)?.zoneName || ""); 
                      }}
                    >
                      <option value="">-- Choose Zone --</option>
                      {[...DATA.zones].sort((a, b) => a.zoneName.localeCompare(b.zoneName)).map((z) => (<option key={z.id} value={z.id}>{z.zoneName.toUpperCase()}</option>))}
                    </Form.Select>
                  </Form.Group>

                  {/* Select: Office */}
                  <Form.Group as={Col} xs={12} sm={6} md={4}>
                    <Form.Label className="small fw-bold text-muted text-uppercase mb-1" style={{ fontSize: '0.7rem' }}>
                      Office <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select 
                      className="shadow-none border-secondary-subtle fw-semibold"
                      style={{ height: '40px', fontSize: '14px' }}
                      name="officeId" 
                      value={formData.officeId || ""} 
                      onChange={(e) => { 
                        handleChange(e); 
                        set_off(formOffices.find(v => v.id === e.target.value)?.officeName || ""); 
                      }} 
                      disabled={!formData.zoneId}
                    >
                      <option value="">-- Choose Office --</option>
                      {[...formOffices].sort((a, b) => a.officeName.localeCompare(b.officeName)).map((o) => (<option key={o.id} value={o.id}>{o.officeName.toUpperCase()}</option>))}
                    </Form.Select>
                  </Form.Group>

                  {/* Multi-Select: Managed By */}
                  <Form.Group as={Col} xs={12} md={8}> {/* Increased width for multi-select visibility */}
                    <Form.Label className="small fw-bold text-muted text-uppercase mb-1" style={{ fontSize: '0.7rem' }}>
                      Managed By <span className="text-danger">*</span>
                    </Form.Label>
                    <Select 
                      isClearable 
                      isMulti 
                      isDisabled={user.role === "user"} 
                      options={option_User || []} 
                      value={users1 || []} 
                      placeholder="Select staff names..." 
                      onChange={(val) => set_users(val ? [...val] : [])}
                      styles={selectStyles} // Reusing your high-z-index styles
                      menuPortalTarget={document.body} // Crucial to prevent cropping
                    />
                  </Form.Group>
                </Row>
              </Card.Body>
            </Card>

            <div className="d-flex justify-content-center align-items-center mb-5 px-3">
  
  {/* --- STEP 1 NODE --- */}
  <div 
    className="d-flex flex-column align-items-center position-relative"
    style={{ cursor: 'pointer' }} 
    onClick={() =>{
      if(!validateCurrentStep(2)) return;
      setCurrentStep(1)
    }}
  >
    <div style={{
      width: '40px', height: '40px', borderRadius: '50%',
      display: 'flex', justifyContent: 'center', alignItems: 'center', 
      fontWeight: 'bold', fontSize: '18px', transition: 'all 0.4s ease',
      boxShadow: currentStep === 1 ? '0 0 0 4px rgba(138, 43, 226, 0.2)' : 'none',
      backgroundColor: isStep1Complete ? '#8a2be2' : (currentStep === 1 ? '#ece917' : '#f7f5a0'),
      color: isStep1Complete ? '#ece917' : '#4a127e',
      border: isStep1Complete ? '2px solid #8a2be2' : '2px solid #ece917',
      zIndex: 2,
      transform: currentStep === 1 ? 'scale(1.1)' : 'scale(1)'
    }}>
      {isStep1Complete ? '✓' : '1'}
    </div>
    <span className="mt-2 fw-bold text-center" style={{ 
      fontSize: '11px', 
      maxWidth: '100px',
      color: isStep1Complete || currentStep === 1 ? '#4a127e' : '#b0b0b0',
      transition: 'color 0.3s'
    }}>
      Applicant Details
    </span>
  </div>
  
  {/* --- LINE CONNECTOR --- */}
  <div style={{ 
    flex: '0 1 120px', 
    height: '4px', 
    borderRadius: '2px',
    backgroundColor: '#f7f5a0', 
    margin: '0 -5px', // Pulls nodes closer
    marginBottom: '18px', // Aligns better with center of circle
    position: 'relative',
    overflow: 'hidden',
    zIndex: 1
  }}>
    <motion.div 
      initial={false} 
      animate={{ width: isStep1Complete ? '100%' : '0%' }} 
      style={{ height: '100%', backgroundColor: '#8a2be2' }} 
    />
  </div>
  
  {/* --- STEP 2 NODE --- */}
  <div 
    className="d-flex flex-column align-items-center position-relative"
    style={{ cursor: 'pointer' }}
    onClick={() =>{
      if(!validateCurrentStep(1)) return;
      setCurrentStep(2)
    }}
  >
    <div style={{
      width: '40px', height: '40px', borderRadius: '50%',
      display: 'flex', justifyContent: 'center', alignItems: 'center', 
      fontWeight: 'bold', fontSize: '18px', transition: 'all 0.4s ease',
      boxShadow: currentStep === 2 ? '0 0 0 4px rgba(236, 233, 23, 0.2)' : 'none',
      backgroundColor: isStep2Complete ? '#8a2be2' : (currentStep === 2 ? '#ece917' : '#f7f5a0'),
      color: isStep2Complete ? '#ece917' : '#4a127e',
      border: isStep2Complete ? '2px solid #8a2be2' : '2px solid #ece917',
      zIndex: 2,
      transform: currentStep === 2 ? 'scale(1.1)' : 'scale(1)'
    }}>
      {isStep2Complete ? '✓' : '2'}
    </div>
    <span className="mt-2 fw-bold text-center" style={{ 
      fontSize: '11px', 
      maxWidth: '100px',
      color: isStep2Complete || currentStep === 2 ? '#4a127e' : '#b0b0b0',
      transition: 'color 0.3s'
    }}>
      Document Process
    </span>
  </div>
</div>

            {/* FORM WRAPPER */}
            <Form onSubmit={handleSubmit}>
              
              {currentStep === 1 && (
                <motion.div initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.3 }}>
                  <Card className="shadow-sm mb-4 border-0 rounded-3 overflow-hidden">
                    <Card.Header className="bg-white border-0 pt-4 px-4">
                      <h5 className="fw-bold mb-0" style={{ color: "#4a127e" }}>
                        Reference & Executant Details
                      </h5>
                      <p className="text-muted small">Enter information for the referring party and the property owner.</p>
                    </Card.Header>
                    
                    <Card.Body className="px-4 pb-4">
                      {/* --- SECTION: REFERRED BY --- */}
                      <div className="mb-4 p-3 rounded-3" style={{ backgroundColor: '#f8f9fa', borderLeft: '4px solid #8a2be2' }}>
                        <h6 className="small fw-bold text-uppercase mb-3" style={{ color: '#8a2be2', letterSpacing: '0.5px' }}>
                          Referred By
                        </h6>
                        <Row className="g-3">
                          <Form.Group as={Col} xs={12} sm={6} md={3}>
                            <Form.Label className="small fw-bold text-muted">NAME {ref?.value?.cid && <span className="badge bg-primary ms-1">{ref.value.cid}</span>}</Form.Label>
                            <CreatableSelect 
                              isClearable 
                              value={ref ? { value: ref.value, label: ref.value?.name?.toUpperCase() } : null} 
                              options={options || []} 
                              onCreateOption={handleCreate_cus} 
                              placeholder="Search..." 
                              onChange={set_ref} 
                              styles={selectStyles}
                              menuPortalTarget={document.body}
                            />
                          </Form.Group>
                          <Form.Group as={Col} xs={12} sm={6} md={3}>
                            <Form.Label className="small fw-bold text-muted">ADDRESS</Form.Label>
                            <Form.Control readOnly value={TitleCase(ref?.value?.address)} className="bg-white border-0 shadow-none fw-semibold" style={{ fontSize: '14px' }} />
                          </Form.Group>
                          <Form.Group as={Col} xs={12} sm={6} md={3}>
                            <Form.Label className="small fw-bold text-muted">DISTRICT</Form.Label>
                            <Form.Control readOnly value={TitleCase(ref?.value?.city)} className="bg-white border-0 shadow-none fw-semibold" style={{ fontSize: '14px' }} />
                          </Form.Group>
                          <Form.Group as={Col} xs={12} sm={6} md={3}>
                            <Form.Label className="small fw-bold text-muted">MOBILE NO.</Form.Label>
                            <Form.Control readOnly value={ref?.value?.mobile || ''} className="bg-white border-0 shadow-none fw-semibold" style={{ fontSize: '14px' }} />
                          </Form.Group>
                        </Row>
                      </div>

                      {/* --- SECTION: EXECUTANT (OWNER) --- */}
                      <div className="p-3 rounded-3" style={{ backgroundColor: '#fffdf5', borderLeft: '4px solid #e7ac2d' }}>
                        <h6 className="small fw-bold text-uppercase mb-3" style={{ color: '#4a127e', letterSpacing: '0.5px' }}>
                          Executant (Owner)
                        </h6>
                        <Row className="g-3">
                          <Form.Group as={Col} xs={12} sm={6} md={3}>
                            <Form.Label className="small fw-bold text-muted">NAME {owner?.value?.cid && <span className="badge bg-success ms-1">{owner.value.cid}</span>}</Form.Label>
                            <CreatableSelect 
                              isClearable 
                              value={owner || null} 
                              options={options || []} 
                              onCreateOption={handleCreate_cus} 
                              placeholder="Search..." 
                              onChange={set_Owner} 
                              styles={selectStyles}
                              menuPortalTarget={document.body}
                            />
                          </Form.Group>
                          <Form.Group as={Col} xs={12} sm={6} md={3}>
                            <Form.Label className="small fw-bold text-muted">ADDRESS</Form.Label>
                            <Form.Control readOnly value={TitleCase(owner?.value?.address)} className="bg-white border-0 shadow-none fw-semibold" style={{ fontSize: '14px' }} />
                          </Form.Group>
                          <Form.Group as={Col} xs={12} sm={6} md={3}>
                            <Form.Label className="small fw-bold text-muted">DISTRICT</Form.Label>
                            <Form.Control readOnly value={TitleCase(owner?.value?.city)} className="bg-white border-0 shadow-none fw-semibold" style={{ fontSize: '14px' }} />
                          </Form.Group>
                          <Form.Group as={Col} xs={12} sm={6} md={3}>
                            <Form.Label className="small fw-bold text-muted">MOBILE NO.</Form.Label>
                            <Form.Control readOnly value={owner?.value?.mobile || ''} className="bg-white border-0 shadow-none fw-semibold" style={{ fontSize: '14px' }} />
                          </Form.Group>
                        </Row>
                      </div>
                    </Card.Body>
                  </Card>
                </motion.div>
              )}

              {/* STEP 2: Document Details */}
              {currentStep === 2 && (
                <motion.div initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.3 }}>
                  <Card className="shadow-sm mb-4 border-0 rounded-3 overflow-hidden">
                    {/* Header with Mode Toggle */}
                    <Card.Header className="bg-white border-0 pt-4 px-4 d-flex justify-content-between align-items-center">
                      <div>
                        <h5 className="fw-bold mb-0" style={{ color: "var(--brand-purple)" }}>Document Process</h5>
                        <p className="text-muted small mb-0">Manage EC applications and delivery tracking.</p>
                      </div>
                      
                      <div className="p-2 rounded-pill border bg-light d-flex align-items-center px-3 shadow-sm">
                        <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                          <Typography sx={{ fontSize: '11px', color: status.status === 'offline' ? '#e7ac2d' : '#adb5bd', fontWeight: 800, textTransform: 'uppercase' }}>Offline</Typography>
                          <AntSwitch 
                            checked={status.status === 'online'} 
                            onChange={handleToggle} 
                            disabled={user.role === "user" && status.click >= 2} 
                          />
                          <Typography sx={{ fontSize: '11px', color: status.status === 'online' ? '#8a2be2' : '#adb5bd', fontWeight: 800, textTransform: 'uppercase' }}>Online</Typography>
                        </Stack>
                      </div>
                    </Card.Header>

                    <Card.Body className="px-4 pb-4">
                      <Row className="g-4">
                        
                        {/* --- EC APPLICATION --- */}
                        <Col xs={12} md={4}>
                          <div className={`p-3 rounded-3 border h-100 ${docDetails.ecno.value === 'yes' ? 'bg-light border-primary-subtle' : 'bg-white'}`}>
                            <Form.Group>
                              <Form.Label className="small fw-bold text-muted text-uppercase mb-2 d-block">
                                Encumbrance Certificate Application {status.status === "online" && "No."} 
                                {status.status === "online" && docDetails.ecno.values === 'yes' && <span className="text-danger ms-1">*</span>}
                              </Form.Label>
                              
                              <div className="mb-3">
                                <ThreeStateToggle 
                                  value={docDetails.ecno.values} 
                                  onChange={(val) => handleDocToggleChange('ecno', val)} 
                                  disabled={!canToggle('ecno')} 
                                />
                              </div>
                              
                              <AnimatePresence>
                                {docDetails.ecno.values === 'yes' && (
                                  <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }}>
                                    <Button 
                                      size="sm" 
                                      className="w-100 py-1 fw-bold rounded-pill mb-3 shadow-sm border-0" 
                                      style={{backgroundColor: '#8a2be2', fontSize: '11px'}}
                                      onClick={() => handleMsg((status.status === "online" ? 'WELCOME1' : 'WELCOME2'), { 
                                        app_no: app_No, 
                                        document_number: `ECA/Online/${docDetails.ecno.no}/${new Date().getFullYear()}` 
                                      })}
                                    >
                                      <i className="bi bi-chat-left-text me-2"></i>COPY WELCOME MSG
                                    </Button>

                                    {status.status === "online" && (
                                      <Form.Control 
                                        className="shadow-none fw-bold" 
                                        value={docDetails.ecno.no || ''} 
                                        onChange={(e) => setDocDetails(p => ({ ...p, ecno: { ...p.ecno, no: e.target.value } }))} 
                                        type="number" 
                                        placeholder="Enter ECA No." 
                                        isInvalid={!docDetails.ecno.no}
                                      />
                                    )}
                                  </motion.div>
                                )}
                              </AnimatePresence>
                            </Form.Group>
                          </div>
                        </Col>

                        {/* --- PAYMENT DETAILS (Offline only) --- */}
                        {status.status === "offline" && (
                          <Col xs={12} md={4}>
                            <div className={`p-3 rounded-3 border h-100 ${docDetails.payment.values === 'yes' ? 'bg-light border-warning-subtle' : 'bg-white'}`}>
                              <Form.Group>
                                <Form.Label className="small fw-bold text-muted text-uppercase mb-2 d-block">
                                  Payment Status {docDetails.payment.values === 'yes' && <span className="text-danger ms-1">*</span>}
                                </Form.Label>
                                <div className="mb-3">
                                  <ThreeStateToggle 
                                    value={docDetails.payment.values} 
                                    onChange={(val) => handleDocToggleChange('payment', val)} 
                                    disabled={!canToggle('payment')} 
                                  />
                                </div>
                                
                                {docDetails.payment.values === 'yes' && (
                                  <div className="input-group input-group-sm">
                                    <span className="input-group-text bg-white text-muted border-end-0">₹</span>
                                    <Form.Control 
                                      className="shadow-none border-start-0 fw-bold" 
                                      value={docDetails.payment.val || ''} 
                                      onChange={(e) => setDocDetails(p => ({ ...p, payment: { ...p.payment, val: e.target.value } }))} 
                                      type="number" 
                                      placeholder="Amount" 
                                      isInvalid={!docDetails.payment.val}
                                    />
                                  </div>
                                )}
                              </Form.Group>
                            </div>
                          </Col>
                        )}

                        {/* --- EC PREPARED --- */}
                        <Col xs={12} md={4}>
                          <div className={`p-3 rounded-3 border h-100 ${docDetails.ec_received.values === 'yes' ? 'bg-light border-success-subtle' : 'bg-white'}`}>
                            <Form.Group>
                              <Form.Label className="small fw-bold text-muted text-uppercase mb-2 d-block">Encumbrance Certificate Prepared</Form.Label>
                              <div className="mb-3">
                                <ThreeStateToggle value={docDetails.ec_received.values} onChange={(val) => handleDocToggleChange('ec_received', val)} disabled={!canToggle('ec_received')} />
                              </div>
                              {docDetails.ec_received.values === 'yes' && (
                                <Button 
                                  size="sm" 
                                  className="w-100 py-1 fw-bold rounded-pill shadow-sm border-0" 
                                  style={{backgroundColor: '#198754', fontSize: '11px'}}
                                  onClick={() => handleMsg((status.status === "online" ? 'COLLECTED' : 'COLLECTED1'), { 
                                    app_no: app_No, 
                                    document_number: `ECA/Online/${docDetails.ecno.no}/${new Date().getFullYear()}`, 
                                    office: typeof off === 'string' ? off.toUpperCase() : off?.value?.toUpperCase() 
                                  })}
                                >
                                  <i className="bi bi-check2-circle me-2"></i>COPY READY MSG
                                </Button>
                              )}
                            </Form.Group>
                          </div>
                        </Col>

                        {/* --- EC DELIVERED --- */}
                        <Col xs={12} md={4}>
                          <div className={`p-3 rounded-3 border h-100 ${docDetails.ec_delivered.values === 'yes' ? 'bg-light border-info-subtle' : 'bg-white'}`}>
                            <Form.Group>
                              <Form.Label className="small fw-bold text-muted text-uppercase mb-2 d-block">Encumbrance Certificate Delivered</Form.Label>
                              <div className="mb-3">
                                <ThreeStateToggle value={docDetails.ec_delivered.values} onChange={(val) => handleDocToggleChange('ec_delivered', val)} disabled={!canToggle('ec_delivered')} />
                              </div>
                            </Form.Group>
                          </div>
                        </Col>

                        {/* --- ESTIMATED COST & FINAL ACTION --- */}
                        <Col xs={12} md={4}>
                          <div className="p-3 rounded-3 border bg-white h-100 shadow-sm border-warning-subtle">
                            <Form.Group className="mb-3">
                              <Form.Label className="small fw-bold text-muted text-uppercase mb-1">Estimated Cost (₹)</Form.Label>
                              <div className="input-group">
                                <span className="input-group-text bg-light border-end-0 text-muted">₹</span>
                                <Form.Control 
                                  className="shadow-none border-start-0 fw-bold" 
                                  value={estimatedCost} 
                                  onChange={(e) => setEstimatedCost(e.target.value)} 
                                  type="number" 
                                  placeholder="0.00" 
                                />
                              </div>
                            </Form.Group>
                            <Button 
                              variant="outline-warning" 
                              className="w-100 fw-bold py-2 rounded-pill shadow-sm" 
                              style={{color: '#4a127e', borderColor: '#dbe72d', borderWidth: '2px'}} 
                              onClick={() => handleMsg((status.status === "online" ? 'THANK' : 'THANK1'), { 
                                app_no: app_No, 
                                document_number: `ECA/Online/${docDetails.ecno.no}/${new Date().getFullYear()}` 
                              })}
                            >
                              <i className="bi bi-star-fill me-2"></i>SEND THANK YOU MSG
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </motion.div>
              )}

              {/* STEPPER NAVIGATION BUTTONS */}
              <div className="d-flex justify-content-between mb-5">
                <Button variant="secondary" onClick={()=>{
                  if(!validateCurrentStep(currentStep)) return
                  setCurrentStep(p=>p-1)
                }} disabled={currentStep === 1}>Back</Button>
                <div className="d-flex gap-2">
                  {currentStep === 1 && <Button style={{backgroundColor: '#8a2be2'}} className="text-white" onClick={()=>{
                  if(!validateCurrentStep(currentStep)) return
                  setCurrentStep(p=>p+1)
                }}>Next Step</Button>}
                  <Button style={{backgroundColor: '#e7ac2d'}} className="text-white fw-bold" disabled={bt} type="submit">{bt ? 'Submitting...' : 'Submit'}</Button>
                </div>
              </div>

            </Form>
          </div>
        </main>
      </div>
      <Footer />

      {/* Background Modals (Same as original) */}
      <AnimatePresence>
        {add && (
          <motion.div key="add-client-modal" initial={{ opacity: 0, scale: 0.95, y: 10 }} animate={{ opacity: 1, scale: 1, y: 0 }} exit={{ opacity: 0, scale: 0.95, y: 10 }} transition={{ duration: 0.2, ease: "easeOut" }} className="modal-overlay-wrapper">
            <AddClient setAdd={setAdd} showToast={showToast} get_customer={fetchClients} />
          </motion.div>
        )}
        {msg && (
          <motion.div key="copy-message-toast" initial={{ opacity: 0, y: 50, scale: 0.9 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: 20, scale: 0.9 }} transition={{ type: "spring", damping: 20, stiffness: 300 }} style={{ position: 'fixed', bottom: '40px', left: '0', right: '0', zIndex: 3000, display: 'flex', justifyContent: 'center', pointerEvents: 'none' }}>
            <div style={{ pointerEvents: 'auto' }}>
              <CopyMsg set_msg={set_msg} content={activeMsgText} />
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default RegistrationEc;